import React from 'react';

const Home = () => {
    return (
        <div className='main'>
            <div className='text-content'>
                <h3>About</h3>

                <p>
                    Tabaṣṣur is a simple web application to view short manuscripts or manuscript excerpts that I've transcribed. All texts here are unpublished unless otherwise noted. It is my hope that this will serve not only as a way to bring attention to unpublished works, but also aid those looking to study Arabic paleography. You can find more of my other research and DH tools on my website <a href="http://www.antoniomusto.com">antoniomusto.com</a>.
                </p>
                <p>
                    The viewer is best used with a resolution of at least 1440x900, ideally full-screen at 1920x1080.
                </p>
                <h3>How to Use</h3>
                <p>
                    You can browse manuscript metadata or you can view the manuscript and the transcription. You will note that there are two buttons at the bottom of the viewer, "Line Box" and "Hover Text". They are both selected by default. Line box will show a highlight box over the respective line in the manuscript image and "Hover Text" will overlay the transcription on the manuscript image. You can toggle them on or off.
                    <img
                        className="about-image"
                        src="media/hover.png"
                        alt="Screenshot demonstrating hover text functionality"
                    />
                    <img
                        className="about-image-mobile"
                        src="media/hover-mobile.png"
                        alt="Screenshot demonstrating hover text functionality"
                    />
                </p>
            </div>
        </div>

    );
};

export default Home;
